import React, { FC } from 'react'

import { Link, Box } from '@material-ui/core'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import DropdownMenu from '~/components/shared/DropdownMenu'

import { sorting } from '~/data/options'

const menuItems = [
  {
    key: 'price_low_to_high',
    child: sorting.price_low_to_high
  },
  {
    key: 'price_high_to_low',
    child: sorting.price_high_to_low
  },
  {
    key: 'newest',
    child: sorting.newest
  },
  {
    key: 'last_updated',
    child: sorting.last_updated
  },
  {
    key: 'oldest',
    child: sorting.oldest
  }
  // {
  //   key: 'featured',
  //   child: 'Featured'
  // }
]

type Peops = {
  onChange: (value) => void
  value: any
}

const SortMenu: FC<Peops> = ({ onChange, value }) => {
  return (
    <DropdownMenu
      menuItems={menuItems}
      defaultValue={value}
      onChange={({ key }) => onChange(key)}
    >
      {({ open, child, onClick }): JSX.Element => (
        <Link
          style={{ cursor: 'pointer' }}
          component="span"
          onClick={onClick}
          color="primary"
          underline="none"
        >
          <Box display="inline-flex" alignItems="center">
            {child}
            <Box component="i" display="inline-flex" mr={1}>
              {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
          </Box>
        </Link>
      )}
    </DropdownMenu>
  )
}

export default SortMenu
